import store, { SIDENAV_CLASSES } from '@/store'

export const DOMAIN_TOP = 'top'
export const DOMAIN_WORKSPACE = 'workspace'
export const DOMAIN_ANY = 'any'

export const WorkspaceStatuses = {
  inProgress: -1,
  inactive: 0,
  unverified: 1,
  active: 10
}

const redirectToTopDomain = (to) => {
  window.location = `https://${store.getters.frontDomain}${to.path}`
}

const redirectToWorkspaceDomain = (to) => {
  const userDomain = store.state.auth.user.domain
  if (userDomain) {
    window.location = `https://${userDomain}.${store.getters.frontDomain}${to.path}`
  } else {
    return false
  }
}

const checkDomain = (requiredDomain) => {
  if (requiredDomain === DOMAIN_ANY) {
    return { redirectRequired: false }
  }

  const workspaceDomain = store.getters.workspaceDomain
  if (requiredDomain === DOMAIN_TOP) {
    return { redirectRequired: workspaceDomain !== '', target: DOMAIN_TOP }
  }

  if (requiredDomain === DOMAIN_WORKSPACE) {
    return { redirectRequired: workspaceDomain === '', target: DOMAIN_WORKSPACE }
  }

  throw new Error(`Unknown required domain type ${requiredDomain}`)
}

export const handleRoute = async (to, from, next) => {
  await store.dispatch('auth/restoreUserBeforeRouting')
  const signed = store.getters['auth/isUserSigned']

  // process requireSigned
  if (to.meta.requireSigned !== undefined) {
    if (!signed && to.meta.requireSigned) {
      to.name === 'login' ? next() : next({ name: 'login', query: { referer: window.location.href } })
      return
    } else if (signed && !to.meta.requireSigned) {
      to.name !== 'home' ? next({ name: 'home' }) : next()
      return
    }
  }

  // process requireDomain
  if (to && to.meta.requireDomain !== undefined) {
    const { redirectRequired, target } = checkDomain(to.meta.requireDomain)
    if (redirectRequired) {
      if (target === DOMAIN_WORKSPACE) {
        if (signed) {
          redirectToWorkspaceDomain(to)
        } else {
          next({ name: 'login' })
          return
        }
      } else {
        redirectToTopDomain(to)
      }
    } else if (target === DOMAIN_WORKSPACE) {
      const workspaceStatus = await store.dispatch('loadWorkspaceStatus')
      if (workspaceStatus.status === 'error') {
        const nativeStatus = workspaceStatus.errors.status
        switch (nativeStatus) {
          case WorkspaceStatuses.inProgress:
          case WorkspaceStatuses.unverified:
            next({ name: 'register-verification' })
            break
          case WorkspaceStatuses.inactive:
            next({ name: 'lock', params: { 0: '' } })
        }
      }
    }
  }

  // close sidenav on route change
  if (store.state.sidenavClass === SIDENAV_CLASSES.expanded) {
    await store.dispatch('setSidenavClass', '')
  }

  next()
}
